import { zodResolver } from "@mantine/form";
import { taskDataSchema } from "beitary-shared";
import { z } from "zod";

const taskFormSchema = taskDataSchema;

export type TaskFormValues = z.infer<typeof taskFormSchema>;

export const rules = zodResolver(taskFormSchema);
